import { SvgIcon, SxProps } from '@mui/material'
import { DirectionContext } from '$setup/root'

interface Props {
  sx?: SxProps
}

export const ArrowIOSIcon = ({ sx, ...props }: Props) => {
  return (
    <DirectionContext.Consumer>
      {direction => {
        return (
          <SvgIcon
            viewBox="0 0 20 20"
            sx={{
              transform: direction === 'ltr' ? 'rotate(180deg)' : '',
              color: 'secondary.main',
              ...sx,
            }}
            {...props}
          >
            <path
              d="M7.64159 9.40825L11.1749 5.87492C11.2524 5.79681 11.3446 5.73481 11.4461 5.69251C11.5477 5.6502 11.6566 5.62842 11.7666 5.62842C11.8766 5.62842 11.9855 5.6502 12.0871 5.69251C12.1886 5.73481 12.2808 5.79681 12.3583 5.87492C12.5135 6.03105 12.6006 6.24226 12.6006 6.46242C12.6006 6.68257 12.5135 6.89378 12.3583 7.04992L9.40826 9.99992L12.3583 12.9499C12.5135 13.1061 12.6006 13.3173 12.6006 13.5374C12.6006 13.7576 12.5135 13.9688 12.3583 14.1249C12.2804 14.2022 12.188 14.2633 12.0865 14.3047C11.985 14.3462 11.8763 14.3672 11.7666 14.3666C11.6569 14.3672 11.5482 14.3462 11.4467 14.3047C11.3451 14.2633 11.2528 14.2022 11.1749 14.1249L7.64159 10.5916C7.56349 10.5141 7.50149 10.4219 7.45918 10.3204C7.41688 10.2188 7.39509 10.1099 7.39509 9.99992C7.39509 9.88991 7.41688 9.78099 7.45918 9.67944C7.50149 9.57789 7.56349 9.48572 7.64159 9.40825Z"
              fill="inherit"
            />
          </SvgIcon>
        )
      }}
    </DirectionContext.Consumer>
  )
}
ArrowIOSIcon.defaultProps = {
  sx: null,
}
